import { useFormContext } from 'rhf-v7';
import {
  getTripFareBreakup,
  FareComponent,
  usePartnerFeatures,
  useGetRequestHeader,
  useMutatePaymentSetup,
  submitVgsForm,
  UserAgent,
} from 'obt-common';
import { ItemType } from 'obt-common/types/api/v2/obt/model/item-type';
import { useParams } from 'react-router-dom';
import { useVgsFormMap } from 'src/app/shared/components/VGSFormProvider/useVgsForm';
import useRetryPaymentService from '../xstate/useRetryPaymentService';
import { RetryPaymentCheckoutFormValues } from '../FormProvider/types';
import useSubmitButtonProps from './useSubmitButtonProps';
import useGetPnr from './useGetPnr';
import { IRetryPaymentParams } from '../types';
import { useIsCvvRequired } from './useIsCvvRequired';
import { useListBookingPaymentSourcesResponse } from './useListBookingPaymentSourcesResponse';
import useGetTravelerProfileResponse from './useGetTravelerProfileResponse';

const useOnSubmit = () => {
  const { watch } = useFormContext<RetryPaymentCheckoutFormValues>();
  const retryPaymentService = useRetryPaymentService();
  const submitButtonProps = useSubmitButtonProps();
  const { pnrId } = useParams<IRetryPaymentParams>();

  const {
    handleSubmit,
    formState: { isValid },
  } = useFormContext<RetryPaymentCheckoutFormValues>();

  const pnr = useGetPnr();

  const selectedPaymentSourceIds = watch('selectedPaymentSourceIds');

  const { features } = usePartnerFeatures();
  const { showServiceFeeTax } = features;

  const fareBreakup = getTripFareBreakup({ pnr, showServiceFeeTax });
  const { totalAmountExcludingServiceFees } = fareBreakup;

  const bookingPaymentDetails = {
    bookingTravelerPaymentDetails: [
      {
        selectedFormOfPayments: [
          {
            paymentItems: [
              {
                itemType: ItemType.TravelTicket,
                fareComponent: [FareComponent.Base, FareComponent.Tax],
              },
            ],
            selectedPaymentSources: [
              {
                paymentSourceId: selectedPaymentSourceIds[0],
              },
            ],
          },
        ],
      },
    ],
  };

  const { cvvRequirement } = useIsCvvRequired();
  const listBookingPaymentSourcesResponse = useListBookingPaymentSourcesResponse();
  const requestHeader = useGetRequestHeader();
  const vgsFormMap = useVgsFormMap();
  const { mutateAsync: mutatePaymentSetup } = useMutatePaymentSetup();
  const primaryTraveler = useGetTravelerProfileResponse();

  const onSubmit = handleSubmit(() => {
    retryPaymentService.send({
      type: 'BEGIN_RETRY',
      pnrId,
      oldTotalFare: totalAmountExcludingServiceFees,
      bookingPaymentDetails,
      cvvRequirement,
      paymentSourceIds: selectedPaymentSourceIds,
      listBookingPaymentSourcesResponse,
      requestHeader,
      primaryTraveler,
      vgsFormMap,
      mutatePaymentSetup,
      submitVgsForm,
      userAgent: UserAgent.WEB,
    });
  });

  return {
    ...submitButtonProps,
    onSubmit,
    disabled: !isValid,
  };
};

export default useOnSubmit;
